// src/secure/odk/ProjectsList.tsx
import React, {Component} from "react";
import Wrapper from "../Wrapper";
import axios from "axios";

type Project = {
    id: number;
    name: string;
    archived?: boolean;
    createdAt?: string;
};

class ProjectsList extends Component {

    state = {
        projects: [] as Project[],
        error: "",
        loading: true,
    };

    async componentDidMount() {
        try {
            /**
             * axios.defaults.baseURL is already set globally to:
             *   http://localhost:8095/api/
             *
             * So this becomes:
             *   GET http://localhost:8095/api/surveys/api/odk/projects
             *
             * Adjust the path string below if your Django route is different.
             */
            const response = await axios.get("surveys/api/odk/projects");

            // response.data should be an array of projects
            const projectsRaw: Project[] = response.data;

            // sort ascending by numeric id
            const projectsSorted = [...projectsRaw].sort((a, b) => {
                // make sure to compare as numbers
                const ida = Number(a.id);
                const idb = Number(b.id);
                if (ida < idb) return -1;
                if (ida > idb) return 1;
                return 0;
            });

            this.setState({
                projects: projectsSorted,
                loading: false,
            });
        } catch (e: any) {
            const msg =
                e?.response?.data?.error ||
                e?.response?.data?.message ||
                e?.message ||
                "Failed to load ODK projects";

            this.setState({
                error: msg,
                loading: false,
            });
        }
    }

    render() {
        const { projects, error, loading } = this.state;

        return (
            <Wrapper>
                <div
                    className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <h2 className="h5 mb-0">Science Technology Indicators - Projects</h2>
                    </div>
                </div>

                {loading && (
                    <p>Loading projects…</p>
                )}

                {!loading && error && (
                    <p style={{color: "crimson"}}>Error: {error}</p>
                )}

                {!loading && !error && (
                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Archived</th>
                                <th>Created</th>
                            </tr>
                            </thead>
                            <tbody>
                            {projects.map((p: Project) => (
                                <tr key={p.id}>
                                    <td>{p.id}</td>
                                    <td>{p.name}</td>
                                    <td>{p.archived ? "Yes" : "No"}</td>
                                    <td>
                                        {p.createdAt
                                            ? new Date(p.createdAt).toLocaleString()
                                            : ""}
                                    </td>
                                </tr>
                            ))}

                            {projects.length === 0 && (
                                <tr>
                                    <td colSpan={4}>No projects found.</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                )}
            </Wrapper>
        );
    }
}

export default ProjectsList;
